import { render, staticRenderFns } from "./SupsisButtonOld.vue?vue&type=template&id=4e00f881"
import script from "./SupsisButtonOld.vue?vue&type=script&lang=js"
export * from "./SupsisButtonOld.vue?vue&type=script&lang=js"
import style0 from "./SupsisButtonOld.vue?vue&type=style&index=0&id=4e00f881&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports